import dynamic from "next/dynamic";
import { createElement } from "react";
import { PartName, SVGPartComponent } from "@/types/design";
import { Success } from "@/types/result";

const sortKeys = (keys: string[]): string[] => {
	const partString = "Part";
	const partStringLength = partString.length;
	return keys.sort((a: string, b: string) => {
		const numA: number = parseInt(
			a.substring(a.lastIndexOf(partString) + partStringLength),
		);
		const numB: number = parseInt(
			b.substring(b.lastIndexOf(partString) + partStringLength),
		);
		return numA - numB;
	});
};

export const GetAllPartComponent = async () => {
	try {
		const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/part/get`;
		const res = await fetch(url);
		const json = await res.json();
		const partFileNames = json.data;
		return new Success(partFileNames);
	} catch (error) {
		console.error("Server component fetch error:", error);
		throw error;
	}
};

const PART_NAME_TO_FILE_NAME_MAP = {
	hair: "HairPart",
	backHair: "BackHairPart",
	eyebrows: "EyebrowsPart",
	eyeline: "EyelinePart",
	eyes: "EyesPart",
	mouth: "MouthPart",
};

export const GetEditedPartComponent = (partName: PartName, partId: string) => {
	const fileName = `${PART_NAME_TO_FILE_NAME_MAP[partName]}${partId}`;
	return dynamic(
		() => import(`./${partName}/${fileName}.tsx`),
	) as SVGPartComponent;
};

export const GetBodyPartComponent = async (
	partName: PartName,
	partId: string,
) => {
	if (partId !== undefined) {
		const fileName = `${PART_NAME_TO_FILE_NAME_MAP[partName]}${partId}.tsx`;

		const importedModule = dynamic(
			() => import(`./${partName}/${fileName}`),
		) as SVGPartComponent;

		return importedModule;
	} else {
		return undefined;
	}
};

export const importFiles = async (
	fileNames: string[],
	partName: string,
	toPreview: boolean,
) => {
	const sortedFiles = sortKeys(fileNames);
	const parts: { id: string; part: any }[] = [];

	for (let i = 0; i < sortedFiles.length; i++) {
		const file = sortedFiles[i];
		const importedModule = await import(`./${partName}/${file}`);
		parts.push({
			id: String(i + 1),
			part: toPreview
				? importedModule.default
				: createElement(importedModule.default),
		});
	}

	return { [partName]: parts };
};
